import type { ShortCode } from '@highereducation/wordpress';
import {
  SortableTableAdapter,
  type SortableTableAdapterProps,
} from './SortableTableAdapter';

export { SortableTableAdapter } from './SortableTableAdapter';
export type { SortableTableAdapterProps } from './SortableTableAdapter';
export { SortableTableClient } from './SortableTableClient';
export type { SortableTableClientProps, CellData } from './SortableTableClient';

export const SortableTableShortcode: ShortCode<SortableTableAdapterProps> = {
  component: SortableTableAdapter,
};

/**
 * [hen-ui-sortable-table-head] — defines a single column header.
 * Rendered as a no-op; the parent SortableTableAdapter reads the text
 * content via `shortcode_name` + `children`.
 */
export const SortableTableHeadShortcode: ShortCode = {
  component: () => null,
};

/**
 * [hen-ui-sortable-table-row] — wraps a set of [hen-ui-sortable-table-cell]
 * shortcodes representing one data row. Rendered as a no-op; the parent
 * SortableTableAdapter reads cells from its children.
 */
export const SortableTableRowShortcode: ShortCode = {
  component: () => null,
};

/**
 * [hen-ui-sortable-table-cell] — a single cell value inside a row.
 * Rendered as a no-op; the parent SortableTableAdapter reads the text
 * content via `shortcode_name` + `children`.
 */
export const SortableTableCellShortcode: ShortCode = {
  component: () => null,
};
